export const isPanelSmall = (panel) => {
  if (panel.width < 0.9 || panel.height < 0.9) return true;
  return false;
};
